import { type HTMLAttributes, type ReactNode } from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hoverable?: boolean;
}
export function Card({
  children,
  hoverable = false,
  className = '',
  ...props
}: CardProps) {
  return (
    <div
      className={`
        bg-navy-light border border-navy-lighter rounded-lg overflow-hidden
        ${hoverable ? 'hover:bg-navy-hover hover:border-gray-600 transition-all cursor-pointer' : ''}
        ${className}
      `}
      {...props}>
      
      {children}
    </div>);

}